import styled from "@emotion/styled";
import { ButtonUnstyled, buttonUnstyledClasses } from "@mui/base";

export default styled(ButtonUnstyled)(
    () => `
          &:hover {
            background: rgba(64, 82, 137, 0.7);
            display: flex;
            color: #FFFFFF !important;
            align-items: center;
            gap: 10px;
          }
        
          &.${buttonUnstyledClasses.active} {
            background-color: #222C4B;
            display: flex;
            align-items: center;
            gap: 10px;
          }
  
          &.${buttonUnstyledClasses.root} {
            display: flex;
            align-items: center;
            gap: 10px;
          }
          
          &.${buttonUnstyledClasses.focusVisible} {
            display: flex;
            align-items: center;
            gap: 10px;
            box-shadow: 0 3px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
            outline: none;
          }
        
          &.${buttonUnstyledClasses.disabled} {
            display: flex;
            align-items: center;
            gap: 7px;
            opacity: 0.5;
            cursor: not-allowed;
          }`
);
